import React from "react";
import { TextArea } from "../FormFields";
import Loader from "../Loader";
import { ModalActions, Button } from "../Buttons";
import "./SaveModal.css";

const SaveModal = ({
  isOpen,
  onClose,
  onSave,
  title = "Save",
  subtitle = "",
  editorName = localStorage.getItem("user_name") || "Unknown User",
  comment,
  onCommentChange,
  isLoading = false,
  closeButtonText = "Close",
  saveButtonText = "Save",
  showLoader = false,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !isLoading) {
      onClose();
    }
  };

  return (
    <div className="save-modal-overlay" onClick={handleOverlayClick}>
      <div className="save-modal-content">
        {/* Header */}
        <div className="save-modal-header">
          <h4 className="save-modal-title">{title}</h4>
          <Button
            onClick={onClose}
            className="save-modal-close-button"
            disabled={isLoading}
            style={{ backgroundColor: "white" }}
            ariaLabel="Close"
          >
            ✕
          </Button>
        </div>

        {/* Body */}
        <div className="save-modal-body">
          {subtitle && (
            <h4 className="save-modal-subtitle">{subtitle}</h4>
          )}

          <p className="save-modal-info">
            <strong>Editor:</strong>
            <span className="save-modal-editor-name">{editorName}</span>
          </p>

          <div className="save-modal-comment-section">
            <TextArea
              label="Comment"
              value={comment}
              onChange={onCommentChange}
              placeholder="Enter your comments here..."
              required
              style={{ width: "100%", marginLeft: "-1px" }}
              labelStyle={{ fontSize: "14px", color: "#333333" }}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="save-modal-footer">
          <ModalActions
            onClose={onClose}
            onSubmit={onSave}
            cancelText={closeButtonText}
            submitText={saveButtonText}
            disabled={isLoading}
            loading={showLoader && isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default SaveModal;

